/*
 * Cabeçalho curva (sections/header-curva.liquid).
 * - Mede a aba e publica as medidas em variáveis CSS (painéis encaixam embaixo dela).
 * - Abre/fecha o painel "Loja" (hover no desktop, toque/clique, Esc, clique fora).
 * - Marca data-open na .hc quando busca, sacola, conta ou menu do celular estão abertos,
 *   para a aba e o painel virarem uma peça só.
 * - Mantém --header-height / --header-group-height do tema atualizados.
 */
(function () {
  function init(hc) {
    if (hc.__hcReady) return;
    hc.__hcReady = true;

    var root = document.documentElement;
    var section = hc.closest('.shopify-section') || hc;
    var tab = hc.querySelector('[data-hc-tab]');
    var megaBtn = hc.querySelector('[data-hc-mega-btn]');
    var mega = hc.querySelector('[data-hc-mega]');
    var drawer = hc.querySelector('[data-hc-drawer]');
    var drawerBtn = hc.querySelector('[data-hc-drawer-btn]');
    var desk = window.matchMedia('(min-width: 960px)');
    var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');
    var openTimer = null;
    var closeTimer = null;

    /* só grava a variável quando o valor muda: gravar no :root/body a cada quadro de rolagem
       faz o navegador recalcular o estilo da página inteira */
    var vars = {};
    function sv(el, k, v) {
      var key = (el === root ? 'r' : 'b') + k;
      if (vars[key] === v) return;
      vars[key] = v;
      el.style.setProperty(k, v);
    }
    function measure() {
      if (!tab) return;
      var r = tab.getBoundingClientRect();
      var vw = root.clientWidth;
      sv(root, '--hc-tabw-px', r.width + 'px');
      if ((r.width < 400) !== hc.hasAttribute('data-narrow')) hc.toggleAttribute('data-narrow', r.width < 400);
      sv(root, '--hc-panel-top', Math.round(r.bottom) + 'px');
      sv(root, '--hc-frame-x', Math.max(0, vw - r.right) + 'px');
      sv(root, '--hc-frame-l', Math.max(0, r.left) + 'px');
      sv(root, '--hc-drawer-top', Math.round(Math.max(0, section.getBoundingClientRect().top) + 6) + 'px');
      sv(document.body, '--header-height', Math.round(section.offsetHeight) + 'px');
      var group = document.getElementById('header-group');
      var h = 0;
      if (group) {
        Array.prototype.forEach.call(group.children, function (el) {
          if (el !== section && el instanceof HTMLElement) h += el.offsetHeight;
        });
        sv(document.body, '--header-group-height', h + 'px');
      }
      /* sacola no celular: 6px abaixo do menu na posição de repouso (faixa + 56px), como no protótipo */
      sv(root, '--hc-cart-top', Math.max(Math.round(r.bottom) + 6, h + 56) + 'px');
    }

    /* ícone da sacola igual ao protótipo (o do tema é outro desenho) */
    function bagIcon() {
      var svg = hc.querySelector('cart-icon svg');
      if (!svg || svg.getAttribute('data-hc-bag')) return;
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('data-hc-bag', '');
      svg.innerHTML = '<path d="M5.5 8h13l-1 12h-11z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/>';
    }

    function stuck() {
      var top = section.getBoundingClientRect().top;
      var on = window.scrollY > 0 && top <= 0.5;
      if (on === hc.hasAttribute('data-stuck')) return;
      if (on) hc.setAttribute('data-stuck', '');
      else hc.removeAttribute('data-stuck');
    }

    function setOpen(kind) {
      if ((kind || null) === hc.getAttribute('data-open')) return;
      if (kind) hc.setAttribute('data-open', kind);
      else hc.removeAttribute('data-open');
    }

    /* ---------- painel Loja ---------- */
    function showMega() {
      if (!mega || !desk.matches) return;
      clearTimeout(closeTimer);
      closeOthers('mega');
      measure();
      setOpen('mega');
      megaBtn.setAttribute('aria-expanded', 'true');
    }
    function hideMega() {
      if (!mega) return;
      clearTimeout(openTimer);
      if (hc.getAttribute('data-open') === 'mega') setOpen(null);
      if (megaBtn) megaBtn.setAttribute('aria-expanded', 'false');
    }
    function closeOthers(keep) {
      if (keep !== 'search') {
        var sd = document.querySelector('#search-modal dialog[open]');
        var sm = document.getElementById('search-modal');
        if (sd && sm && typeof sm.closeDialog === 'function') sm.closeDialog();
      }
      if (keep !== 'cart') {
        var cd = hc.querySelector('cart-drawer-component');
        var cdd = cd && cd.querySelector('dialog[open]');
        if (cdd && typeof cd.close === 'function') cd.close();
      }
      if (keep !== 'mega' && hc.getAttribute('data-open') === 'mega') hideMega();
    }

    if (megaBtn && mega) {
      megaBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (hc.getAttribute('data-open') === 'mega') hideMega();
        else showMega();
      });
      megaBtn.addEventListener('pointerenter', function () {
        if (!hoverable.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(showMega, 90);
      });
      [megaBtn, mega].forEach(function (el) {
        el.addEventListener('pointerleave', function () {
          if (!hoverable.matches) return;
          clearTimeout(openTimer);
          closeTimer = setTimeout(hideMega, 220);
        });
        el.addEventListener('pointerenter', function () {
          if (el === mega) clearTimeout(closeTimer);
        });
      });
      tab.addEventListener('pointerenter', function (e) {
        if (e.target === tab && hc.getAttribute('data-open') === 'mega') clearTimeout(closeTimer);
      });
      var cats = mega.querySelectorAll('[data-hc-cat]');
      var panes = mega.querySelectorAll('[data-hc-pane]');
      function pick(id) {
        cats.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-hc-cat') === id); });
        panes.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-hc-pane') === id); });
      }
      cats.forEach(function (c) {
        c.addEventListener('pointerenter', function () { pick(c.getAttribute('data-hc-cat')); });
        c.addEventListener('focus', function () { pick(c.getAttribute('data-hc-cat')); });
      });
      document.addEventListener('click', function (e) {
        if (hc.getAttribute('data-open') !== 'mega') return;
        if (mega.contains(e.target) || megaBtn.contains(e.target)) return;
        hideMega();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && hc.getAttribute('data-open') === 'mega') {
        hideMega();
        if (megaBtn) megaBtn.focus();
      }
    });

    /* ---------- busca (uma peça só: no celular dentro do menu, no desktop no painel encaixado) ---------- */
    var openDrawerFn = null;
    var closeDrawerFn = null;
    var search = (function () {
      var box = hc.querySelector('[data-hcs]');
      if (!box) return null;
      var input = box.querySelector('[data-hcs-input]');
      var form = box.querySelector('[data-hcs-form]');
      var res = box.querySelector('[data-hcs-res]');
      var none = box.querySelector('[data-hcs-none]');
      var recBox = box.querySelector('[data-hcs-recent]');
      var recList = box.querySelector('[data-hcs-reclist]');
      var base = box.getAttribute('data-search-url') || '/search';
      var KEY = 'plenty:buscas';
      var timer = null;
      var ctrl = null;
      var last = '';

      function readRecent() {
        try { return JSON.parse(localStorage.getItem(KEY) || '[]').filter(Boolean).slice(0, 4); } catch (e) { return []; }
      }
      function saveRecent(q) {
        q = (q || '').trim();
        if (q.length < 2) return;
        var list = readRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
        list.unshift(q);
        try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 4))); } catch (e) {}
      }
      function dropRecent(q) {
        var list = readRecent().filter(function (x) { return x !== q; });
        try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
        drawRecent();
      }
      function esc(t) {
        return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
      }
      function drawRecent() {
        var list = readRecent();
        recBox.hidden = !list.length;
        recList.innerHTML = list.map(function (q) {
          return '<div class="hcs__rr"><a href="#" data-hcs-q="' + esc(q) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span>' + esc(q) + '</span></a>' +
            '<button type="button" data-hcs-drop="' + esc(q) + '" aria-label="Remover ' + esc(q) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17"/></svg></button></div>';
        }).join('');
      }
      var scroller = box.querySelector('.hcs__b');
      function show(state) {
        if (scroller && state !== box.__state) scroller.scrollTop = 0;
        box.__state = state;
        box.classList.toggle('has-q', state !== 'idle');
        res.hidden = state !== 'hit';
        none.hidden = state !== 'none';
      }
      function run() {
        var q = input.value.trim();
        clearTimeout(timer);
        if (!q) { last = ''; if (ctrl) ctrl.abort(); show('idle'); return; }
        if (q === last) return;
        timer = setTimeout(function () {
          last = q;
          if (ctrl) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          var url = base + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=plenty-search-suggest';
          fetch(url, ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.text(); })
            .then(function (html) {
              if (input.value.trim() !== q) return;
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var out = doc.querySelector('[data-hcsr]');
              var n = out ? parseInt(out.getAttribute('data-count'), 10) || 0 : 0;
              res.innerHTML = '';
              if (n > 0) { res.appendChild(document.importNode(out, true)); show('hit'); if (scroller) scroller.scrollTop = 0; }
              else show('none');
            })
            .catch(function () {});
        }, 180);
      }
      input.addEventListener('input', run);
      form.addEventListener('submit', function (e) {
        if (!input.value.trim()) { e.preventDefault(); return; }
        saveRecent(input.value);
      });
      box.addEventListener('click', function (e) {
        var drop = e.target.closest('[data-hcs-drop]');
        if (drop) { e.preventDefault(); dropRecent(drop.getAttribute('data-hcs-drop')); input.focus({ preventScroll: true }); return; }
        var chip = e.target.closest('[data-hcs-q]');
        if (chip) {
          e.preventDefault();
          input.value = chip.getAttribute('data-hcs-q');
          run();
          input.focus({ preventScroll: true });
          return;
        }
        if (e.target.closest('[data-hcs-close]')) {
          var sm = document.getElementById('search-modal');
          if (sm && typeof sm.closeDialog === 'function') sm.closeDialog();
          return;
        }
        if (e.target.closest('[data-hcs-keep], .pcc a')) saveRecent(input.value);
      });

      return {
        box: box,
        /* coloca a busca dentro de um lugar (menu do celular ou painel do desktop) */
        place: function (parent, before) {
          if (box.parentNode !== parent) parent.insertBefore(box, before || null);
          input.placeholder = parent === hc.querySelector('.hcd') ? 'Buscar...' : 'Buscar na Plenty';
        },
        start: function () {
          drawRecent();
          if (!input.value.trim()) show('idle');
          setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
        }
      };
    })();
    function searchToDialog() {
      var dlg = document.querySelector('#search-modal dialog');
      if (!search || !dlg) return;
      search.place(dlg, null);
      search.start();
    }
    /* celular: a lupa abre o menu em modo busca (como no protótipo), no lugar do painel nativo */
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-hc-search]');
      if (!b || !hc.contains(b) || desk.matches || !search || !openDrawerFn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var hcdEl = hc.querySelector('.hcd');
      if (drawer && drawer.open && hcdEl && hcdEl.dataset.mode === 'search') closeDrawerFn();
      else openDrawerFn('search');
    }, true);

    /* ---------- menu do celular ---------- */
    if (drawer && drawerBtn) {
      var stack = drawer.querySelector('[data-hcd-stack]');
      var hcd = drawer.querySelector('.hcd');
      var sheetFrom = null;
      /* folhas de baixo (Sua conta, País e moeda) */
      function openSheet(name, from) {
        var sh = drawer.querySelector('[data-hcd-sheet="' + name + '"]');
        if (!sh) return;
        closeSheet(true);
        sheetFrom = from || null;
        sh.removeAttribute('inert');
        sh.classList.add('is-on');
        hcd.classList.add('has-sheet');
        var f = sh.querySelector('a, button');
        if (f) f.focus({ preventScroll: true });
      }
      function closeSheet(silent) {
        var any = false;
        drawer.querySelectorAll('[data-hcd-sheet]').forEach(function (sh) {
          if (sh.classList.contains('is-on')) any = true;
          sh.classList.remove('is-on');
          sh.setAttribute('inert', '');
        });
        if (hcd) hcd.classList.remove('has-sheet');
        if (any && !silent && sheetFrom) sheetFrom.focus({ preventScroll: true });
        if (!silent) sheetFrom = null;
        return any;
      }
      function goLevel(id) {
        if (!stack) return;
        stack.dataset.at = id || 'root';
        stack.querySelectorAll('[data-hcd-lv]').forEach(function (lv) {
          lv.classList.toggle('is-at', lv.getAttribute('data-hcd-lv') === (id || 'root'));
        });
        drawer.querySelectorAll('[data-hcd-go]').forEach(function (b) {
          b.setAttribute('aria-expanded', b.getAttribute('data-hcd-go') === id ? 'true' : 'false');
        });
        var target = stack.querySelector('[data-hcd-lv="' + (id || 'root') + '"]');
        if (target) {
          target.scrollTop = 0;
          var f = id ? target.querySelector('[data-hcd-back]') : drawer.querySelector('[data-hcd-go="' + stack.__last + '"]');
          if (f) f.focus({ preventScroll: true });
        }
        if (id) stack.__last = id;
      }
      function openDrawer(mode) {
        closeOthers('drawer');
        measure();
        drawer.classList.remove('is-closing');
        if (hcd) hcd.dataset.mode = mode === 'search' ? 'search' : 'menu';
        goLevel(null);
        if (mode === 'search' && search) search.place(hcd, stack);
        if (!drawer.open) drawer.showModal();
        if (mode === 'search' && search) search.start();
        /* rodapé: tira o "·" de quem começa linha nova */
        var prevTop = null;
        drawer.querySelectorAll('.hcd__fl > *').forEach(function (a) {
          a.classList.remove('is-line');
          var t = a.offsetTop;
          if (prevTop !== null && t > prevTop + 4) a.classList.add('is-line');
          prevTop = t;
        });
      }
      function closeDrawer() {
        if (!drawer.open || drawer.classList.contains('is-closing')) return;
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) { drawer.close(); return; }
        drawer.classList.add('is-closing');
        setTimeout(function () {
          drawer.classList.remove('is-closing');
          drawer.close();
          closeSheet(true);
          if (hcd) hcd.dataset.mode = 'menu';
          if (stack) { stack.dataset.at = 'root'; goLevel(null); }
        }, 190);
      }
      drawerBtn.addEventListener('click', function () {
        if (drawer.open) closeDrawer();
        else openDrawer('menu');
      });
      openDrawerFn = openDrawer;
      closeDrawerFn = closeDrawer;
      var closeBtn = drawer.querySelector('[data-hc-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      drawer.addEventListener('cancel', function (e) {
        e.preventDefault();
        if (closeSheet()) return;
        if (hcd && hcd.dataset.mode === 'search') { closeDrawer(); return; }
        if (stack && stack.dataset.at !== 'root') goLevel(null);
        else closeDrawer();
      });
      drawer.addEventListener('click', function (e) {
        var go = e.target.closest('[data-hcd-go]');
        if (go) { goLevel(go.getAttribute('data-hcd-go')); return; }
        if (e.target.closest('[data-hcd-back]')) { goLevel(null); return; }
        var op = e.target.closest('[data-hcd-open]');
        if (op) { openSheet(op.getAttribute('data-hcd-open'), op); return; }
        if (e.target.closest('[data-hcd-dim]')) { closeSheet(); return; }
        if (e.target === drawer) {
          var r = drawer.getBoundingClientRect();
          var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
          if (!inside) closeDrawer();
        }
      });
      if (stack) goLevel(null);
    }

    /* ---------- estado aberto: busca, sacola, conta, menu ---------- */
    function syncOpen() {
      var kind = null;
      if (drawer && drawer.open) kind = 'drawer';
      else if (hc.querySelector('cart-drawer-component dialog[open]')) kind = 'cart';
      else if (document.querySelector('#search-modal dialog[open]')) kind = 'search';
      else if (hc.getAttribute('data-open') === 'mega') kind = 'mega';
      setOpen(kind);
      if (drawerBtn) drawerBtn.setAttribute('aria-expanded', drawer && drawer.open ? 'true' : 'false');
      if (kind === 'search' || kind === 'cart') hideMegaSilently();
      if (kind === 'search' && search && search.box.parentNode !== document.querySelector('#search-modal dialog')) searchToDialog();
    }
    function hideMegaSilently() {
      if (megaBtn) megaBtn.setAttribute('aria-expanded', 'false');
    }
    var mo = new MutationObserver(function () {
      measure();
      syncOpen();
    });
    /* diálogos dentro do menu (sacola, menu do celular) podem ser trocados quando o tema
       re-renderiza o cabeçalho depois de mexer na sacola: observa a subárvore inteira */
    mo.observe(hc, { attributes: true, attributeFilter: ['open'], subtree: true });
    var sdlg = document.querySelector('#search-modal dialog');
    if (sdlg) mo.observe(sdlg, { attributes: true, attributeFilter: ['open'] });

    /* o tema re-renderiza o cabeçalho (sacola atualizada) e apaga os atributos de estado:
       reaplica medidas e estado logo depois */
    var fixing = false;
    function refresh() {
      if (fixing) return;
      fixing = true;
      requestAnimationFrame(function () {
        fixing = false;
        bagIcon();
        stuck();
        measure();
        syncOpen();
      });
    }
    new MutationObserver(refresh).observe(hc, { attributes: true, attributeFilter: ['data-open', 'data-stuck', 'data-narrow'] });
    document.addEventListener('cart:update', function () { setTimeout(refresh, 0); setTimeout(refresh, 600); });
    var searchBtn = hc.querySelector('[data-hc-search]');
    if (searchBtn) searchBtn.addEventListener('click', function () {
      if (!desk.matches) return;
      closeOthers('search');
      measure();
      searchToDialog();
    });
    var cartBtn = hc.querySelector('cart-drawer-component > button');
    if (cartBtn) cartBtn.addEventListener('click', function () { closeOthers('cart'); measure(); }, true);

    /* ---------- medidas ---------- */
    if (window.ResizeObserver && tab) {
      new ResizeObserver(function () { measure(); }).observe(tab);
    }
    window.addEventListener('resize', measure);
    var raf = null;
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; stuck(); measure(); });
    }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    desk.addEventListener('change', function () { hideMega(); if (drawer && drawer.open && desk.matches) drawer.close(); measure(); });
    bagIcon();
    measure();
    stuck();
  }

  function boot() {
    document.querySelectorAll('[data-hc]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
